import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyA5AC_OyqgoReZeSifFuC36r6SmeMKQMi4",
  authDomain: "loyaltea-46e52.firebaseapp.com",
  databaseURL: "https://loyaltea-46e52-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "loyaltea-46e52",
  storageBucket: "loyaltea-46e52.firebasestorage.app",
  messagingSenderId: "528134035046",
  appId: "1:528134035046:web:57341325cfe4c604ad7fa7",
  measurementId: "G-S42ZDGRS7T"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);